// Mappers: camelCase (Zustand) ↔ snake_case (Supabase)
// Each table has its own mapper to handle specific field renames

const TABLE_FIELD_MAP = {
  transactions: {
    toDb: {
      linkedTo: 'linked_to',
      memberIds: 'member_ids',
      unitId: 'unit_id',
      businessId: 'business_id',
      projectId: 'project_id',
      exchangeRate: 'exchange_rate',
      exchangedFrom: 'exchanged_from',
      clientName: 'client_name',
      supplierName: 'supplier_name',
      propertyId: 'property_id',
      personalProjectId: 'personal_project_id',
    },
    fromDb: {
      linked_to: 'linkedTo',
      member_ids: 'memberIds',
      unit_id: 'unitId',
      business_id: 'businessId',
      project_id: 'projectId',
      exchange_rate: 'exchangeRate',
      exchanged_from: 'exchangedFrom',
      client_name: 'clientName',
      supplier_name: 'supplierName',
      property_id: 'propertyId',
      personal_project_id: 'personalProjectId',
      user_id: null, // strip
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  budgets: {
    toDb: {},
    fromDb: {
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  goals: {
    toDb: {
      memberIds: 'member_ids',
    },
    fromDb: {
      member_ids: 'memberIds',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  members: {
    toDb: {
      photoUrl: 'photo_url',
    },
    fromDb: {
      photo_url: 'photoUrl',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  splits: {
    toDb: {
      myShare: 'my_share',
      partnerShare: 'partner_share',
    },
    fromDb: {
      my_share: 'myShare',
      partner_share: 'partnerShare',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  banks: {
    toDb: {
      memberIds: 'member_ids',
    },
    fromDb: {
      user_id: null,
      couple_id: null,
      member_ids: 'memberIds',
      created_at: null,
      updated_at: null,
    },
  },
  credits: {
    toDb: {
      bankId: 'bank_id',
      memberIds: 'member_ids',
      totalAmount: 'total_amount',
      installmentAmount: 'installment_amount',
      totalInstallments: 'total_installments',
      paidInstallments: 'paid_installments',
      startDate: 'start_date',
    },
    fromDb: {
      bank_id: 'bankId',
      total_amount: 'totalAmount',
      installment_amount: 'installmentAmount',
      total_installments: 'totalInstallments',
      paid_installments: 'paidInstallments',
      start_date: 'startDate',
      member_ids: 'memberIds',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  income_units: {
    toDb: {
      grossIncome: 'gross_income',
      memberIds: 'member_ids',
    },
    fromDb: {
      gross_income: 'grossIncome',
      member_ids: 'memberIds',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  fixed_costs: {
    toDb: {
      incomeUnitId: 'income_unit_id',
    },
    fromDb: {
      income_unit_id: 'incomeUnitId',
      user_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  properties: {
    toDb: {
      creditId: 'credit_id',
      rentAmount: 'rent_amount',
      tenantName: 'tenant_name',
      tenantContact: 'tenant_contact',
      memberIds: 'member_ids',
    },
    fromDb: {
      credit_id: 'creditId',
      rent_amount: 'rentAmount',
      tenant_name: 'tenantName',
      tenant_contact: 'tenantContact',
      member_ids: 'memberIds',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  tenant_expenses: {
    toDb: {
      propertyId: 'property_id',
    },
    fromDb: {
      property_id: 'propertyId',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  businesses: {
    toDb: {},
    fromDb: {
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  projects: {
    toDb: {
      businessId: 'business_id',
      startDate: 'start_date',
      endDate: 'end_date',
    },
    fromDb: {
      business_id: 'businessId',
      start_date: 'startDate',
      end_date: 'endDate',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  milestones: {
    toDb: {
      projectId: 'project_id',
      dueDate: 'due_date',
    },
    fromDb: {
      project_id: 'projectId',
      due_date: 'dueDate',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  resource_collaborators: {
    toDb: {
      resourceType: 'resource_type',
      resourceId: 'resource_id',
      ownerId: 'owner_id',
      collaboratorId: 'collaborator_id',
      memberId: 'member_id',
      collabType: 'collab_type',
    },
    fromDb: {
      resource_type: 'resourceType',
      resource_id: 'resourceId',
      owner_id: 'ownerId',
      collaborator_id: 'collaboratorId',
      member_id: 'memberId',
      collab_type: 'collabType',
      created_at: null,
      updated_at: null,
    },
  },
  personal_projects: {
    toDb: {
      estimatedCost: 'estimated_cost',
      memberIds: 'member_ids',
    },
    fromDb: {
      estimated_cost: 'estimatedCost',
      member_ids: 'memberIds',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  personal_project_items: {
    toDb: {
      personalProjectId: 'personal_project_id',
      estimatedCost: 'estimated_cost',
    },
    fromDb: {
      personal_project_id: 'personalProjectId',
      estimated_cost: 'estimatedCost',
      user_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  agenda_items: {
    toDb: {
      transactionId: 'transaction_id',
    },
    fromDb: {
      transaction_id: 'transactionId',
      user_id: null,
      couple_id: null,
      created_at: null,
      updated_at: null,
    },
  },
  app_settings: {
    toDb: {
      chatEnabled: 'chat_enabled',
      businessEnabled: 'business_enabled',
      scanEnabled: 'scan_enabled',
      propertiesEnabled: 'properties_enabled',
    },
    fromDb: {
      chat_enabled: 'chatEnabled',
      business_enabled: 'businessEnabled',
      scan_enabled: 'scanEnabled',
      properties_enabled: 'propertiesEnabled',
      user_id: null,
      created_at: null,
      updated_at: null,
    },
  },
};

function mapObject(obj, fieldMap) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    if (key in fieldMap) {
      const mapped = fieldMap[key];
      if (mapped === null) continue; // strip field
      result[mapped] = value;
    } else {
      result[key] = value;
    }
  }
  return result;
}

export function toDb(table, obj) {
  const map = TABLE_FIELD_MAP[table];
  if (!map) return obj;
  return mapObject(obj, map.toDb);
}

export function fromDb(table, obj) {
  const map = TABLE_FIELD_MAP[table];
  if (!map) return obj;
  return mapObject(obj, map.fromDb);
}

export function toDbArray(table, arr) {
  return arr.map((item) => toDb(table, item));
}

export function fromDbArray(table, arr) {
  return arr.map((item) => fromDb(table, item));
}

// Store key → Supabase table name
export const STORE_TO_TABLE = {
  transactions: 'transactions',
  budgets: 'budgets',
  goals: 'goals',
  members: 'members',
  splits: 'splits',
  banks: 'banks',
  credits: 'credits',
  incomeUnits: 'income_units',
  properties: 'properties',
  tenantExpenses: 'tenant_expenses',
  businesses: 'businesses',
  projects: 'projects',
  personalProjects: 'personal_projects',
  agendaItems: 'agenda_items',
  appSettings: 'app_settings',
};

// Table name → Store key
export const TABLE_TO_STORE = Object.fromEntries(
  Object.entries(STORE_TO_TABLE).map(([k, v]) => [v, k])
);

// Keys that are synced arrays (not single objects)
export const ARRAY_KEYS = [
  'transactions', 'budgets', 'goals', 'members', 'splits',
  'banks', 'credits', 'incomeUnits', 'properties', 'tenantExpenses', 'businesses', 'projects', 'personalProjects', 'agendaItems',
];
